"use client"

import { CheckMark, CloseIcon, Data, Online, Presencial } from '@/components/Icons';
import { Eventos } from '@prisma/client';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import Link from 'next/link';
import React, { useState } from 'react'
import {
    confirmarPresencaEvento
} from '@/components/Pages/Eventos/actions';
import { Button } from "@/components/ui/button";


import dayjs from "dayjs"
import 'dayjs/locale/pt-br'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { OctagonAlert } from "lucide-react";

export type Props = {
    evento: Pick<Eventos, 'EVE_IDEN' | 'EVE_TITULO' | 'EVE_DATA_INICIO' | 'EVE_DATA_FIM' | 'EVE_MODALIDADE_INSCRICAO' | 'EVE_QRCODE' | 'EVE_URL_ACESSO'>,
    participanteId: string,
    statusInscricao: 'CONFIRMADO' | ""
}

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault('America/Sao_Paulo');

export default function ButtonConfirmed({ evento, participanteId, statusInscricao }: Props) {
    const isConfirmed = statusInscricao === 'CONFIRMADO';
    const [showModal, setShowModal] = useState(false);
    const handleModalToggle = () => {
        setShowModal(!showModal);
    };

    const handleConfirm = async () => {
        const response = await confirmarPresencaEvento(evento.EVE_IDEN!, participanteId,);
        if (response.status === 200) {
            alert(response.message)
            handleModalToggle()
        }

    }

    const endDate = dayjs(evento?.EVE_DATA_FIM).utc().locale('pt-br')
    const todayDate = dayjs().locale('pt-br')

    if (todayDate > endDate) {
        return (
            <Button variant="destructive" className="max-lg:fixed max-lg:bottom-10 max-lg:left-10 max-lg:right-10 max-lg:z-10 max-lg:shadow-xl ">Incrições encerradas</Button>
        )
    }

    return (
        <>
            {
                        <Button onClick={handleModalToggle} variant="pucicon"
                            className="max-lg:fixed max-lg:bottom-10 max-lg:left-10 max-lg:right-10 max-lg:z-10 max-lg:shadow-xl "
                        >
                            {isConfirmed ? <span>Inscrição Confirmada</span> : <span>Inscreva-se na atividade</span>}
                        </Button>
        
                    }

            {
                showModal && (
                    <div className="fixed bg-gray-700/40 w-full h-screen z-20 overflow-hidden  left-0 right-0 top-0 bottom-0">

                        <div className="fixed  top-1/2 transform -translate-y-1/2 left-0 right-0 z-50 p-4 overflow-hidden " onClick={handleModalToggle}>
                            <div onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-full m-auto bg-white rounded-lg">
                                <div className="flex justify-end p-6">
                                    <button
                                        type="button"
                                        className=""
                                        onClick={handleModalToggle}
                                    >
                                        <CloseIcon className=' transition-all hover:opacity-70' />
                                    </button>
                                </div>
                                <div className="max-sm:px-6 px-20 py-2 mx-auto max-sm:pb-10 pb-20">
                                    <h3 className=' text-[26px] font-semibold text-puc-blue-secondary leading-7 max-sm:text-center'>{evento.EVE_TITULO}</h3>

                                    <div className='mt-4 flex max-sm:flex-col items-center justify-between'>
                                        <div className='flex max-sm:gap-6 sm:gap-20'>

                                            <p className='flex gap-2 items-center text-base text-puc-blue-secondary font-medium'>
                                                <Data fill='#1D3C85' />
                                                {format(new Date(evento.EVE_DATA_INICIO), 'd MMM yyyy', { locale: ptBR })} {evento.EVE_DATA_FIM && ` - ${format(new Date(evento.EVE_DATA_FIM), 'd MMM yyyy', { locale: ptBR })}`}
                                            </p>

                                            {
                                                evento?.EVE_MODALIDADE_INSCRICAO && (
                                                    <div className="flex gap-2 items-center text-puc-blue-secondary">
                                                        {evento?.EVE_MODALIDADE_INSCRICAO === 'PRESENCIAL' ? <Presencial fill="text-puc-blue-secondary" /> : <Online fill="text-puc-blue-secondary" />}
                                                        <p className="text-base font-medium text-puc-blue-secondary">
                                                            {evento?.EVE_MODALIDADE_INSCRICAO}
                                                        </p>
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                    {
                                        isConfirmed && (
                                            <div className="flex gap-2 items-center mt-3">
                                                <CheckMark />
                                                <p className="text-base text-puc-green-primary font-medium">Inscrição Confirmada</p>
                                            </div>

                                        )
                                    }

                                    {
                                        isConfirmed && evento?.EVE_MODALIDADE_INSCRICAO === 'ONLINE' ? (
                                            <div className=' my-10 py-7 space-y-1 border-t-[2px] border-b-[2px] border-[#D6D6D6] text-lg text-puc-blue-secondary'>
                                                <p className=' font-light '>Link de acesso:</p>
                                                <Link href={evento.EVE_URL_ACESSO ?? "#"} target='_blank' className=' font-medium underline line-clamp-1'>
                                                    Acessar o evento
                                                </Link>
                                            </div>
                                        ) : null
                                    }

                                    {
                                        !isConfirmed && (

                                            <Button
                                                onClick={handleConfirm}
                                                className="text-lg text-center font-bold rounded-full mx-auto py-3 w-full transition-all hover:opacity-70 mt-5 text-white bg-puc-green-primary">
                                                Confirmar Inscrição
                                            </Button>
                                        )
                                    }

                                    <div className="flex flex-col items-center gap-1 mt-3 text-gray-600 text-center">
                                        <OctagonAlert size={24} />
                                        <p className="text-xs">A inscrição inicial não confirma sua participação. Confirme seu comparecimento durante o evento, escaneando o QR Code e inserindo o código fornecido. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )

}


